export const environment = {
  production: false,
  apiUrl: 'https://alpha.emilegal.com/api/',
  googleClientId: '491202270735-2iv5l6bp0v68e3o9n3endd04ssa8un9l.apps.googleusercontent.com',
  adminBaseUrl: 'https://alpha.emilegal.com/admin/',
  emiBaseUrl: 'https://alpha.emilegal.com/'
};
